import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { User, Building, Mail, Phone, Gem } from 'lucide-react';

export const UserDashboard = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen px-6 md:px-12 lg:px-24 py-12">
      <div className="max-w-4xl mx-auto space-y-12">
        <div data-testid="user-dashboard-header">
          <h1 className="font-heading text-4xl md:text-5xl font-semibold mb-4">Welcome Back</h1>
          <p className="text-muted-foreground text-lg">Manage your account and browse our premium diamond collection</p>
        </div>

        {/* Account Info */}
        <div className="bg-white border border-border p-8 space-y-6" data-testid="account-info-card">
          <h2 className="font-heading text-2xl font-semibold mb-6">Account Information</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <div className="flex items-center gap-3 text-muted-foreground text-sm uppercase tracking-widest">
                <User size={16} />
                Name
              </div>
              <div className="font-semibold text-lg">{user?.first_name} {user?.last_name}</div>
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-3 text-muted-foreground text-sm uppercase tracking-widest">
                <Building size={16} />
                Company
              </div>
              <div className="font-semibold text-lg">{user?.company_name}</div>
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-3 text-muted-foreground text-sm uppercase tracking-widest">
                <Mail size={16} />
                Email
              </div>
              <div className="font-semibold">{user?.email}</div>
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-3 text-muted-foreground text-sm uppercase tracking-widest">
                <Phone size={16} />
                Contact
              </div>
              <div className="font-semibold">{user?.contact_number}</div>
            </div>
          </div>

          <div className="pt-6 border-t border-border">
            <div className="flex items-center justify-between">
              <span className="text-sm uppercase tracking-widest text-muted-foreground">Account Status</span>
              <span className={`px-4 py-2 text-xs uppercase tracking-widest font-bold ${
                user?.status === 'approved' ? 'bg-primary/10 text-primary border border-primary' :
                user?.status === 'pending' ? 'bg-yellow-500/10 text-yellow-700 border border-yellow-500' :
                'bg-red-500/10 text-red-700 border border-red-500'
              }`}>
                {user?.status}
              </span>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link 
            to="/catalog"
            className="bg-primary text-white hover:bg-primary/90 p-8 transition-all duration-300 group"
            data-testid="browse-catalog-card"
          >
            <Gem className="mb-4 group-hover:scale-110 transition-transform" size={40} />
            <h3 className="font-heading text-2xl font-semibold mb-2">Browse Catalog</h3>
            <p className="text-white/80">Explore our premium diamond collection with full pricing access</p>
          </Link>

          <div className="bg-white border border-border p-8">
            <Phone className="mb-4 text-primary" size={40} />
            <h3 className="font-heading text-2xl font-semibold mb-2">Need Help?</h3>
            <p className="text-muted-foreground mb-4">Contact our team for personalized assistance</p>
            <a href="tel:+918128741058" className="text-primary hover:underline font-semibold">
              +91 8128741058
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};